import { makeStyles } from "@material-ui/core/styles";

const useTableStyles = makeStyles((theme) => ({
  tableContainer: {
    flex: 1,
    padding: 0,
    border: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.06)"
      : "1px solid #E2E8F0",
    borderRadius: 12,
    overflow: "hidden",
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  tableHead: {
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "#F8FAFC",
  },
  tableHeadCell: {
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    fontSize: 12,
    fontWeight: 600,
    fontFamily: '"Inter", "Poppins", sans-serif',
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    padding: "14px 16px",
    borderBottom: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.06)"
      : "1px solid #E2E8F0",
    whiteSpace: "nowrap",
  },
  tableRow: {
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(255,255,255,0.03)"
        : "#F8FAFC",
    },
    "&:last-child td": {
      borderBottom: "none",
    },
  },
  tableCell: {
    fontSize: 14,
    fontFamily: '"Inter", "Poppins", sans-serif',
    color: theme.palette.type === "dark" ? "#E2E8F0" : "#334155",
    padding: "12px 16px",
    borderBottom: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.04)"
      : "1px solid #F1F5F9",
  },
  tableCellBold: {
    fontSize: 14,
    fontWeight: 600,
    fontFamily: '"Inter", "Poppins", sans-serif',
    color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
    padding: "12px 16px",
    borderBottom: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.04)"
      : "1px solid #F1F5F9",
  },
  actionButtonGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
  },
  actionButton: {
    width: 34,
    height: 34,
    borderRadius: 8,
    transition: "all 0.15s ease",
    color: theme.palette.type === "dark" ? "#94A3B8" : "#94A3B8",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(255,255,255,0.08)"
        : "#F1F5F9",
      color: theme.palette.type === "dark" ? "#E2E8F0" : "#334155",
    },
  },
  actionButtonEdit: {
    "&:hover": {
      backgroundColor: "rgba(59, 130, 246, 0.08)",
      color: "#3B82F6",
    },
  },
  actionButtonDelete: {
    "&:hover": {
      backgroundColor: "rgba(239, 68, 68, 0.08)",
      color: "#EF4444",
    },
  },
  actionButtonBlock: {
    "&:hover": {
      backgroundColor: "rgba(245, 158, 11, 0.08)",
      color: "#F59E0B",
    },
  },
  actionButtonSuccess: {
    "&:hover": {
      backgroundColor: "rgba(34, 197, 94, 0.08)",
      color: "#22C55E",
    },
  },
  actionButtonChannel: {
    "&:hover": {
      backgroundColor: "rgba(53, 175, 154, 0.08)",
      color: "#35af9a",
    },
  },
  statusChip: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 12,
    fontWeight: 600,
    height: 26,
    borderRadius: 6,
  },
  statusActive: {
    backgroundColor: "rgba(34, 197, 94, 0.1)",
    color: "#16A34A",
  },
  statusInactive: {
    backgroundColor: "rgba(239, 68, 68, 0.1)",
    color: "#DC2626",
  },
  statusPending: {
    backgroundColor: "rgba(245, 158, 11, 0.1)",
    color: "#D97706",
  },
  statusSent: {
    backgroundColor: "rgba(34, 197, 94, 0.1)",
    color: "#16A34A",
  },
  statusError: {
    backgroundColor: "rgba(239, 68, 68, 0.1)",
    color: "#DC2626",
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#FFFFFF",
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 14,
      "& fieldset": {
        borderColor: theme.palette.type === "dark"
          ? "rgba(255,255,255,0.08)"
          : "#E2E8F0",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.type === "dark"
          ? "rgba(255,255,255,0.15)"
          : "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#35af9a",
        borderWidth: 1.5,
      },
    },
    "& .MuiInputBase-root": {
      borderRadius: 10,
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 14,
    },
    "& .MuiInput-underline:before": {
      borderBottom: theme.palette.type === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid #E2E8F0",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: theme.palette.type === "dark"
        ? "1px solid rgba(255,255,255,0.2)"
        : "1px solid #CBD5E1",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "2px solid #35af9a",
    },
  },
  addButton: {
    borderRadius: 10,
    textTransform: "none",
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontWeight: 600,
    fontSize: 14,
    padding: "8px 20px",
    boxShadow: "0 1px 3px rgba(53, 175, 154, 0.2)",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(53, 175, 154, 0.3)",
    },
  },
  pagination: {
    borderTop: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.06)"
      : "1px solid #F1F5F9",
    "& .MuiTablePagination-toolbar": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 13,
    },
    "& .MuiTablePagination-selectRoot": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 13,
    },
    "& .MuiTablePagination-caption": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      fontSize: 13,
      color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    },
  },
  avatarCell: {
    width: 44,
    height: 44,
    border: theme.palette.type === "dark"
      ? "2px solid rgba(255,255,255,0.08)"
      : "2px solid #E2E8F0",
  },
}));

export default useTableStyles;

